import userProfileRoleTypes from 'helpers/enums/userProfileRoleTypes'

const ROLE_NAMES = {
	['1']: userProfileRoleTypes.TEACHER,
	['2']: userProfileRoleTypes.INSTRUCTIONAL_COACH,
	['3']: userProfileRoleTypes.LIBRARY_MEDIA_SPECIALIST,
	['4']: userProfileRoleTypes.PURCHASING_SECRETARY,
	['5']: userProfileRoleTypes.SCHOOL_ADMINISTRATOR,
	['6']: userProfileRoleTypes.DISTRICT_ADMINISTRATOR,
	['7']: userProfileRoleTypes.PARENT_HOMESCHOOL,
	['8']: userProfileRoleTypes.OTHER_SCHOOL_EMPLOYEE,
	['9']: userProfileRoleTypes.STUDENT,
}
const getRoleNameById = roleId => (ROLE_NAMES[roleId] || '')

export {
	getRoleNameById,
}
